import { FormHelperText, Icon, InputAdornment, TextField, Box } from '@mui/material';
import { FormControl } from './index';
import PropTypes from 'prop-types';
import { IconButton } from 'node_modules/@mui/material/index';
import moment from 'moment';

const TextBox = (props) => {
  const {
    name,
    label,
    variant,
    type,
    InputLabelProps,
    icon,
    value,
    required,
    multiline,
    inputAdornmentPosition = 'end',
    fullWidth,
    helperText,
    disabled,
    rows,
    onKeyDown,
    isAdornment = false,
    isAlphanumeric,
    isMaxLenght,
    onIconClick,
    placeholder,
    iconDisabled,
    isDisabledPastAndPresent,
    styled,sx,
    size,
    min,
    max,
    validateText = true,
    inputRef
  } = props;

  return (
    <FormControl key={`key${name}`} error={helperText ? true : false} fullWidth={fullWidth}>
      <TextField
      size={size}
        sx={sx}
        error={helperText ? true : false}
        variant={variant}
        name={name}
        label={label}
        type={type}
        style={{height: '50px!important'}}
        onKeyDown={onKeyDown}
        rows={rows}
        InputLabelProps={InputLabelProps}
        placeholder={placeholder}
        multiline={multiline}
        required={required}
        disabled={disabled}
        autoComplete={'false'}
        inputRef={inputRef}
        value={value}
        onChange={(e) => props.onChange(e)}
        inputProps={{ maxLength: isMaxLenght ? isMaxLenght : null, min: isDisabledPastAndPresent || min, style: styled, max: max }}
        InputProps={{
          endAdornment: (
            <>
              {isAdornment && (
                <InputAdornment position={inputAdornmentPosition}>
                  <IconButton disabled={iconDisabled} onClick={onIconClick}>
                    <Icon>{icon}</Icon>
                  </IconButton>
                </InputAdornment>
              )}
            </>
          ),
        }}
      />
      <Box sx={{ display: 'flex' }}>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
        {isAlphanumeric && (
          <FormHelperText sx={{ marginTop: '0px', marginBottom: '10px', color: '#637381!important' }}>
            must be format Alphanumeric, Alphabetical, Numeric or Dashed Characters (Ex: ABCDE-323 and ABCDE-12-343)
          </FormHelperText>
        )}
        {isMaxLenght && (
          <FormHelperText sx={{ marginTop: '0px', marginBottom: '10px', color: '#637381!important' }}>
            {validateText && `Must be characters limit ${isMaxLenght}`}
          </FormHelperText>
        )}
      </Box>
    </FormControl>
  );
};

TextBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.string,
  type: PropTypes.string,
  InputLabelProps: PropTypes.string,
  icon: PropTypes.string,
  inputAdornmentPosition: PropTypes.string,
  required: PropTypes.bool,
  multiline: PropTypes.string,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
  rows: PropTypes.string,
  onKeyDown: PropTypes.func,
  isAdornment: PropTypes.any,
  isAlphanumeric: PropTypes.any,
  isMaxLenght: PropTypes.any,
  onIconClick: PropTypes.any,
  placeholder: PropTypes.any,
  iconDisabled: PropTypes.any,
  isDisabledPastAndPresent: PropTypes.any,
  validateText:PropTypes.bool,
};

export default TextBox;
